import {useLayoutEffect} from 'react'
import {auth} from './api'
import {useM} from './hooks'
import {createLatestRequests} from './latest-requests'

// Account and view ownership belongs to the committed React view. The same
// controller orders accepted writes while a new binding rejects old callbacks.
export function useRequestOwner(...view:any[]) {
    const [{user,token}]=auth.use()
    const key=JSON.stringify(view)
    const requests=useM(()=>createLatestRequests(()=>JSON.stringify([auth.get().user,auth.get().token])))
    const binding=useM(key,user,token,()=>({generation:-1}))
    useLayoutEffect(()=>{
        requests.enter(key);binding.generation=requests.generation
        return ()=>requests.leave()
    },[requests,key,user,token,binding])
    const current=()=>requests.activeFor(key,binding.generation)
    const begin=(lane:string)=>current()?requests.begin(lane,key):undefined
    return {requests,key,binding,current,begin,auth:{user,token},
        later(lane:string,work:()=>void,delay=0) {
            const request=begin('later:'+lane)
            if(!request)return
            const timer=setTimeout(()=>{try{if(request.current())work()}finally{request.finish()}},delay)
            request.own(()=>clearTimeout(timer))
        },
    }
}
